import { render, staticRenderFns } from "./GroupInformation.vue?vue&type=template&id=6aac3848"
import script from "./GroupInformation.js?vue&type=script&lang=js&external"
export * from "./GroupInformation.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports